var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, AfterContentInit, QueryList } from '@angular/core';
import { HammerGestureConfig, } from '@angular/platform-browser';
var DotHammerConfig = /** @class */ (function (_super) {
    __extends(DotHammerConfig, _super);
    function DotHammerConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DotHammerConfig.prototype.buildHammer = function (element) {
        var mc = new Hammer(element, {
            touchAction: "pan-y"
        });
        return mc;
    };
    return DotHammerConfig;
}(HammerGestureConfig));
export { DotHammerConfig };
var DotNavigationPage = /** @class */ (function () {
    function DotNavigationPage() {
    }
    return DotNavigationPage;
}());
export { DotNavigationPage };
var DotNavigationComponent = /** @class */ (function () {
    function DotNavigationComponent(elementRef) {
        this.elementRef = elementRef;
        this.numPages = [];
        this.page = 0;
        this.SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
    }
    DotNavigationComponent.prototype.ngAfterContentInit = function () {
        for (var i = 0; i < this.pages.length; i++) {
            this.numPages.push(i);
        }
    };
    DotNavigationComponent.prototype.nextPage = function (nextPage) {
        var jump = nextPage - this.page;
        var child = this.elementRef.nativeElement.querySelector(".dot-navigation");
        child.scrollLeft += jump * child.offsetWidth;
        this.page = nextPage;
    };
    DotNavigationComponent.prototype.swipe = function (action) {
        if (action === void 0) { action = this.SWIPE_ACTION.RIGHT; }
        var nextPage = 0;
        if (action == this.SWIPE_ACTION.RIGHT) {
            nextPage = this.page - 1;
            nextPage = (nextPage < 0) ? (this.numPages.length - 1) : nextPage;
        }
        else {
            nextPage = this.page + 1;
            nextPage = (nextPage > this.numPages.length - 1) ? 0 : nextPage;
        }
        this.nextPage(nextPage);
    };
    return DotNavigationComponent;
}());
export { DotNavigationComponent };
